import React from "react";

// import { FaWhatsapp } from "react-icons/fa";
import { trackHeroWhatsAppClick } from "../utils/analytics";

interface BackgroundStyle extends React.CSSProperties {
  backgroundImage: string;
}

const HeroSection: React.FC = () => {
  const backgroundStyle: BackgroundStyle = {
    backgroundImage: "url(/hero_bg.jpg)",
  };

  const handleWhatsAppClick = (): void => {
    trackHeroWhatsAppClick();
  };

  return (
    <section
      id="hero"
      className="w-full flex flex-col justify-between items-center px-4 py-4 min-h-[100svh] bg-cover bg-center bg-no-repeat relative"
      style={backgroundStyle}
    >
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>

      {/* Spacer to push content down */}
      <div className="flex-1 min-h-[72px]"></div>

      {/* Hero content container */}
      <div className="relative z-10 text-center space-y-8 w-full max-w-[85%] md:max-w-[80%] lg:max-w-[75%] flex-shrink-0">
        <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black text-white font-display leading-tight">
          <span className="block">Travel. Explore.</span>
          <span className="block bg-gradient-to-r from-pink-300 to-purple-300 bg-clip-text text-transparent leading-tight pb-2">
            Safer. Together.
          </span>
        </h1>

        <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-white/90 font-medium leading-relaxed max-w-4xl mx-auto">
          India&apos;s verified community for women travellers — connect, share,
          and discover trusted travel experiences.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 md:gap-12 text-base sm:text-lg md:text-xl text-white/80 font-medium">
          <span className="flex items-center gap-2">
            <span className="text-pink-300 font-bold">Join city groups.</span>
          </span>
          <span className="flex items-center gap-2">
            <span className="text-purple-300 font-bold">
              Talk with real women travellers.
            </span>
          </span>
          <span className="flex items-center gap-2">
            <span className="text-pink-300 font-bold">
              Find your next plan safely.
            </span>
          </span>
        </div>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
          <a
            href="#signup-form"
            onClick={handleWhatsAppClick}
            className="inline-block bg-pink-500 text-white px-6 py-3 sm:px-8 sm:py-4 md:px-10 md:py-5 rounded-xl sm:rounded-2xl shadow-2xl font-bold sm:font-black text-base sm:text-lg md:text-xl border border-white/30 sm:border-2 hover:bg-pink-600 hover:shadow-pink-500/50 hover:shadow-2xl w-fit"
          >
            <span className="flex items-center gap-1 sm:gap-4">
              {/* <FaWhatsapp className="text-xl sm:text-2xl md:text-3xl drop-shadow-lg" /> */}
              <span className="drop-shadow-lg text-sm sm:text-base md:text-lg lg:text-xl">
                Request Exclusive Access
              </span>
            </span>
          </a>
          <a
            href="#why-cohop"
            className="inline-block bg-white/20 backdrop-blur-sm text-white px-6 py-3 sm:px-8 sm:py-4 md:px-10 md:py-5 rounded-xl sm:rounded-2xl shadow-2xl font-bold sm:font-black text-base sm:text-lg md:text-xl border border-white/30 sm:border-2 hover:bg-white/30 hover:shadow-white/20 hover:shadow-2xl w-fit transition-all duration-300"
          >
            <span className="drop-shadow-lg text-sm sm:text-base md:text-lg lg:text-xl">
              Explore how Cohop works
            </span>
          </a>
        </div>
      </div>

      {/* Bottom spacer to ensure CTA is always visible - accounts for mobile address bars */}
      <div className="flex-shrink-0 h-16 sm:h-12 md:h-16"></div>
    </section>
  );
};

export default HeroSection;
